import { Component } from '@angular/core';

@Component({
  selector: 'app-empty',
  template: '<router-outlet></router-outlet>',
})
export class EmptyComponent {}
